<template>
  <div class="container">
    <vue-tel-input
      mode="international"
      @input="updateValue"
      class="phone-input"
      defaultCountry="us"
      :onlyCountries="countries"
      :placeholder="placeholder"
      :maxLen="15"
      inputClasses="phone-input-container"
    />
    <div v-if="error !== ''" class="error">{{ error }}</div>
  </div>
</template>

<script>
import { VueTelInput } from "vue-tel-input";
export default {
  components: {
    VueTelInput,
  },
  props: {
    type: {
      type: String,
      default: "text",
    },
    error: {
      type: String,
      default: "",
    },
    placeholder: {
      type: String,
      default: "",
    },
    maxlength: {
      type: String,
      default: "",
    },
  },
  methods: {
    updateValue: function (value, obj) {
      this.$emit("input", value, obj);
    },
  },
  data() {
    return {
      countries: ["us"],
    };
  },
};
</script>

<style>
::placeholder {
  color: #696969;
  font-weight: 600;
}
.container {
  margin-bottom: 20px;
  background-color: #fafafa;
}
.phone-input-container {
  background-color: #fafafa !important;
}
.phone-input {
  border-radius: 5px;
  height: 50px;
  border: 1px solid #eeeeee !important;
  font-size: 16px;
  font-weight: 600;
}
.error {
  color: red;
  margin-top: 8px;
  font-weight: 600;
  text-align: left;
}
</style>